module.exports = __webpack_public_path__ + "static/media/retail.8f07d4b7.svg";